<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex d-block xs12>
        <v-card>
          <v-card-text>
            <FirstScreen v-if="walldash.currentScreen == 0"
                         :caseRegistrationStats="walldash.caseRegistrationStats"
                         :grossingByDoctorsStats="walldash.grossingByDoctorsStats"
            ></FirstScreen>
            <SecondScreen v-if="walldash.currentScreen == 1"
                          :grossingByLabManagersStats="walldash.grossingByLabManagersStats"
                          :glassesMicrotomedStats="walldash.glassesMicrotomedStats"></SecondScreen>
            <ThirdScreen v-if="walldash.currentScreen == 2"
                         :glassesScannedStats="walldash.glassesScannedStats"
                         :doctorOwnersStats="walldash.doctorOwnersStats"
                         :collaboratorsStats="walldash.collaboratorsStats"></ThirdScreen>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import {mapActions, mapState} from 'vuex'
import FirstScreen from './Walldash/FirstScreen'
import SecondScreen from './Walldash/SecondScreen'
import ThirdScreen from './Walldash/ThirdScreen'

export default {
  name: 'Walldash',
  components: {
    FirstScreen,
    SecondScreen,
    ThirdScreen
  },
  computed: {
    ...mapState({
      walldash: 'walldash'
    })
  },
  created () {
    this.walldashInit()
  },
  methods: {
    ...mapActions({
      walldashInit: 'wdInit'
    })
  }
}
</script>

<style scoped>

</style>

<style>
  table {
    word-break: break-word !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Walldash.vue